import { useContext } from "react";
import { useHistory } from "react-router-dom";

import { RoutingRouterContext } from "./RoutingStateContext";
import { RouterLike } from "./types";

export const useRouterOrHistory = (): RouterLike => {
  const router = useContext(RoutingRouterContext);
  const history = useHistory();
  return router ?? history;
};
